import { Component, OnInit } from "@angular/core";
import { ColorService } from '../../shared/services/color.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from "@angular/forms";
import { OPCConstant } from "../../opc-app/opc.const";
import { NotificationService } from "../../shared/services/notification.service";
import { Message, ConfirmationService } from 'primeng/api';
@Component({
  selector: 'app-color',
  templateUrl: './color.component.html',
  styleUrls: ['./color.component.css']

})
export class ColorComponent implements OnInit {
 
  loading = false;
  public pagedItems: any;
  public startIndex: number;
  public endIndex: number;

  constructor(private colorService: ColorService, private spinner: NgxSpinnerService, private fb: FormBuilder, private notifyService: NotificationService, private confirmationService: ConfirmationService,
  ) {

  }
  addColorForm: any;
  public allColors: any;
  public show: boolean = false;
  ngOnInit(): void {
    
   
    this.getColorItems();
  }

 
  getColorItems() {
    this.colorService.getAllColors().subscribe((color) => {
      if (color) {
        this.allColors = color;
        this.pagedItems = this.allColors.slice(this.startIndex, this.endIndex);
      }
    })
  
  }
   getColors(res) {
     if (res) {
       this.colorService.getAllColors().subscribe((color) => {
        
         this.allColors = color;
         this.pagedItems = this.allColors.slice(this.startIndex, this.endIndex);

       })
     }

  }
  setPageData(data: any) {
    this.pagedItems = this.allColors.slice(data.startIndex, data.endIndex);
    this.startIndex = data.startIndex;
    this.endIndex = data.endIndex;
  }
 
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/color/color.component.ts